import { render, staticRenderFns } from "./RemaxToolbarActions.vue?vue&type=template&id=339b068c&scoped=true&"
import script from "./RemaxToolbarActions.vue?vue&type=script&lang=ts&"
export * from "./RemaxToolbarActions.vue?vue&type=script&lang=ts&"
import style0 from "./RemaxToolbarActions.vue?vue&type=style&index=0&id=339b068c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339b068c",
  null
  
)

export default component.exports
import {QBtn,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QMenu,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QMenu})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
